import { render, staticRenderFns } from "./LocLink.vue?vue&type=template&id=0b8b4db1&"
import script from "./LocLink.vue?vue&type=script&lang=js&"
export * from "./LocLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports